import { render, staticRenderFns } from "./modal-glosario.vue?vue&type=template&id=bb35591a&scoped=true&"
import script from "./modal-glosario.vue?vue&type=script&lang=js&"
export * from "./modal-glosario.vue?vue&type=script&lang=js&"
import style0 from "./modal-glosario.vue?vue&type=style&index=0&id=bb35591a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb35591a",
  null
  
)

export default component.exports